import React from 'react';
import AboutHero from '../components/AboutHero';
import CompanyStats from '../components/CompanyStats';
import OurMission from '../components/OurMission';
import Beliefs from '../components/Beliefs';
import Ourteam from '../components/Ourteam';

const About: React.FC = () => {
  return (
    <div className="pt-20">
      <AboutHero />
      <CompanyStats />
      <OurMission />
      {/* <Beliefs /> */}
      {/* <Ourteam /> */}
    </div>
  );
};

export default About; 